import React from "react";
import PropTypes from "prop-types";
import { formatPhoneNumber } from "@qgiv/core-js";
import { Icon } from "@qgiv/core-react";

const ReceiptShippingDetails = ({
    shippingDetailsLabel,
    shippingMethodName,
    shippingMethodDescription,
    shippingContact,
}) => {
    const { fname, lname, address, city, state, zip, country, phone } =
        shippingContact;

    const hasShippingDetails =
        fname || lname || address || city || state || zip || country || phone;

    if (hasShippingDetails) {
        return (
            <div className="col col--12 col--sm-5 -margin-top--15 -padding-right--30">
                <section>
                    <h3>{shippingDetailsLabel}</h3>
                    <p className="-type--small -margin-top--15">
                        {fname} {lname}
                        <br />
                        {address}
                        {address && <br />}
                        {city}
                        {city && (state || zip) && ","} {state} {zip}
                        {(city || state || zip) && <br />}
                        {country}
                        {country && <br />}
                        {formatPhoneNumber(String(phone))}
                    </p>
                </section>
                {shippingMethodName && (
                    <section>
                        <div className="-callout -margin-top--15">
                            <p>
                                <Icon
                                    className="-margin-right--10"
                                    glyph="shipping-fast-solid"
                                    type="FontAwesome"
                                />
                                {`${shippingMethodName} ${shippingMethodDescription && `(${shippingMethodDescription})`}`}
                            </p>
                        </div>
                    </section>
                )}
            </div>
        );
    }
    return null;
};

ReceiptShippingDetails.propTypes = {
    shippingDetailsLabel: PropTypes.string.isRequired,
    shippingMethodName: PropTypes.string.isRequired,
    shippingMethodDescription: PropTypes.string.isRequired,
    shippingContact: PropTypes.shape({
        fname: PropTypes.string,
        lname: PropTypes.string,
        address: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        zip: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        country: PropTypes.string,
        phone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
};

export default ReceiptShippingDetails;
